export default {
  portfolioBuilderFakeItem: 'portfolio_project_share_with_employers',
  portfolioBuilderSave: 'portfolio_builder_save',
  portfolioBuilderSaveDraft: 'portfolio_builder_save_draft',
  portfolioBuilderOpenCourse: 'portfolio_builder_open_course',
  portfolioBuilderPublish: 'portfolio_builder_publish',
  portfolioBuilderPublishConfirmation: 'portfolio_builder_publish_confirmation',
  portfolioBuilderPublishViewProject: 'portfolio_builder_publish_view_project',
  portfolioBuilderHide: 'portfolio_builder_hide',
  portfolioBuilderLearnMore: 'portfolio_builder_learn_more',
  portfolioBuilderHideConfirmation: 'portfolio_builder_hide_confirmation',
  portfolioEditProjectsDialog: 'portfolio_edit_projects_dialog',
  portfolioAddProjectsDialog: 'portfolio_add_projects_dialog',
} as const;
